/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendPatchedSubscriptionRequestDto } from '../../models/backend-patched-subscription-request-dto';
import { BackendSubscriptionDto } from '../../models/backend-subscription-dto';

export interface SubscriptionActivePartialUpdate$FormData$Params {
  body?: BackendPatchedSubscriptionRequestDto;
}

export function subscriptionActivePartialUpdate$FormData(
  http: HttpClient,
  rootUrl: string,
  params?: SubscriptionActivePartialUpdate$FormData$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendSubscriptionDto>> {
  const rb = new RequestBuilder(rootUrl, subscriptionActivePartialUpdate$FormData.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendSubscriptionDto>;
    }),
  );
}

subscriptionActivePartialUpdate$FormData.PATH = '/api/subscription/active/';
